import { SD_FONTS, SD_HTML_FONT_SIZE } from '../config/sportsDistrictBrand';

export const applySportsDistrictDocumentStyles = (): void => {
  document.body.style.fontFamily = SD_FONTS.display;
  document.documentElement.style.fontSize = `${SD_HTML_FONT_SIZE}px`;
};

export const resetSportsDistrictDocumentStyles = (): void => {
  document.body.style.fontFamily = '';
  document.documentElement.style.fontSize = '';
};
